function PisDeploymentController(stateService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.item = {
      name: 'Deployment',
    };
    ctrl.selectedWorkspace = stateService.getSelectedWorkspace();
  };
}

angular
  .module('pis-tool.module')
  .controller('PisDeploymentController', PisDeploymentController);
